/**
 * Corporate Theme - Main Entry Point
 * Focused on high-performance Vanilla JS and GSAP animations.
 */

// 1. Global Styles
import "../scss/style.scss";

// 2. Image Optimization (Lazysizes)
import "lazysizes";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// 3. Prefetching
import { listen } from "quicklink";

// 4. Header & Navigation
// Note: Header sticky/mobile logic is handled by vendor scripts.js
import { initLanguageSwitcher } from "./parts/header/languageSwitcher";

// 5. Page Content Components
import { initArchiveMasonry } from "./partials/PageContent/archiveMasonry";

// 6. Post/CPT Content Components
import { initVideoFacades } from "./partials/PostContent/video";
import { initGalleries } from "./partials/PostContent/gallery";
import { initAccordions } from "./partials/PostContent/accordion";

// 7. Contact Form
import { initContactForm } from "./templates/contact/contactForm";

/**
 * Initialize all global and component-specific logic.
 * Internal guard clauses in each function prevent errors if
 * the target elements are missing from the current page.
 */
const initGlobals = () => {
  // Parts Initializers
  initLanguageSwitcher();

  // --- Page Section Initializers ---
  initArchiveMasonry();

  // --- Single Post/Service/Project Content Initializers ---
  initVideoFacades();
  initGalleries();
  initAccordions();

  // --- Contact Form Initializer ---
  initContactForm();

  // Start listening for in-viewport links to prefetch
  listen();

  console.log("[Main JS] Corporate Base initialized.");
};

// --- Bootstrap ---
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
